<style>
.ivu-modal-footer {
  border-top: 0;
}
.ivu-modal-header {
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}
</style>

<template>
  <div id="modal-holder">
    <div>
      <Modal v-model="isShow"
        :class-name="classes"
        :width="width"
        :styles="{top: mTop+'px'}"
        :title="title"
        :closable="closable"
        :scrollable="true"
        :transfer="true"
        :mask-closable="false"
        @on-cancel="onClose"
        @on-ok="onClose">
        <div slot="header">
          <slot name="mheader"></slot>
        </div>
        <div :style="{height:mHeight, overflowY: mScrollable}" style="overflow:hidden;">
          <slot name="mcontent"></slot>
        </div>
        <div slot="footer">
          <slot name="mfooter"></slot>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalHolderComponent',
  props: {
    className: {
      type: String,
    },
    closable: {
      type: Boolean,
      default: false
    },
    title: {
      required: true,
      type: String,
      default: 'Modal Name'
    },
    isShow: {
      required: true,
      type: Boolean,
      default: false
    },
    mHeight: {
      default: '70vh',
      type: String
    },
    width: {
      type: String
    },
    mTop: {
      default: '60',
      type: String
    },
    mMargin: {
      type: String,
      default: '10'
    },
    mScrollable: {
      type: String,
      default: 'auto'
    },
  },
  methods: {
    onClose() {
      this.$emit('on-close');
    }
  },
  computed: {
    classes: {
      get() {
        return 'm-modal-wrapper ' + this.className;
      }
    }
  }
}
</script>
